import { useEffect, useState } from "react";
import { ParentGetAttendance } from "services/Parent/ParentServices";
import ParentLoader from "./ParentLoader";
import { PARENT_STATUS_AR, PARENT_STATUS_COLORS } from "constants/constants";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import ParentEmpty from "./ParentEmpty";
import ParentFmt from "./ParentFmt";

const ParentAttendanceTab = ({ studentId, parentInfo }) => {
    const [data, setData] = useState(null);

    useEffect(() => {

        ParentGetAttendance(parentInfo?.token, Number(studentId)).then(r => setData(r.attendance)).catch(() => setData([]));

    }, [studentId]);



    if (!data) return <ParentLoader />;



    const counts = { attend: 0, absent: 0, late: 0, 'left with parent': 0 };

    data.forEach(r => { counts[r.status] = (counts[r.status] || 0) + 1; });



    const chartData = [

        { name: 'حاضر', value: counts.attend, color: PARENT_STATUS_COLORS.attend },

        { name: 'غائب', value: counts.absent, color: PARENT_STATUS_COLORS.absent },

        { name: 'متأخر', value: counts.late, color: PARENT_STATUS_COLORS.late },

        { name: 'انصرف مع الأب', value: counts['left with parent'], color: PARENT_STATUS_COLORS['left with parent'] },

    ].filter(d => d.value > 0);



    return (

        <div className="space-y-6">

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

                <div className="bg-emerald-500/10 dark:bg-emerald-500/20 border border-emerald-500/30 rounded-2xl p-4 text-center">

                    <div className="text-3xl font-black text-emerald-600 dark:text-emerald-400">{counts.attend}</div>

                    <div className="text-base font-bold text-emerald-800 dark:text-emerald-200 mt-1">حاضر</div>

                </div>

                <div className="bg-red-500/10 dark:bg-red-500/20 border border-red-500/30 rounded-2xl p-4 text-center">

                    <div className="text-3xl font-black text-red-600 dark:text-red-400">{counts.absent}</div>

                    <div className="text-base font-bold text-red-800 dark:text-red-200 mt-1">غائب</div>

                </div>

                <div className="bg-amber-500/10 dark:bg-amber-500/20 border border-amber-500/30 rounded-2xl p-4 text-center">

                    <div className="text-3xl font-black text-amber-600 dark:text-amber-400">{counts.late}</div>

                    <div className="text-base font-bold text-amber-800 dark:text-amber-200 mt-1">متأخر</div>

                </div>

                <div className="bg-blue-500/10 dark:bg-blue-500/20 border border-blue-500/30 rounded-2xl p-4 text-center">

                    <div className="text-3xl font-black text-blue-600 dark:text-blue-400">{counts['left with parent']}</div>

                    <div className="text-base font-bold text-blue-800 dark:text-blue-200 mt-1">انصرف مع الأب</div>

                </div>

            </div>



            {chartData.length > 0 && (

                <div className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl p-6 shadow-sm">

                    <h3 className="text-lg font-bold text-watomsBlue dark:text-white mb-4">📊 توزيع الحضور</h3>

                    <ResponsiveContainer width="100%" height={260}>

                        <PieChart>

                            <Pie

                                data={chartData}

                                cx="50%"

                                cy="50%"

                                innerRadius={70}

                                outerRadius={100}

                                paddingAngle={5}

                                dataKey="value"

                            >

                                {chartData.map((entry, index) => (

                                    <Cell key={`cell-${index}`} fill={entry.color} />

                                ))}

                            </Pie>

                            <Tooltip contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' }} />

                            <Legend verticalAlign="bottom" height={36} />

                        </PieChart>

                    </ResponsiveContainer>

                </div>

            )}



            {data.length === 0 ? <ParentEmpty /> : (

                <div className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl overflow-hidden shadow-sm">

                    <div className="overflow-x-auto">

                        <table className="w-full text-base text-right">

                            <thead className="bg-gray-100/80 dark:bg-white/10 text-gray-900 dark:text-gray-100 font-bold border-b border-gray-300 dark:border-white/20">

                                <tr>

                                    <th className="px-6 py-4">التاريخ</th>

                                    <th className="px-6 py-4">الحالة</th>

                                    <th className="px-6 py-4">السبب</th>

                                </tr>

                            </thead>

                            <tbody className="divide-y divide-gray-200 dark:divide-white/5">

                                {data.map(r => (

                                    <tr key={r.id} className="hover:bg-gray-50/50 dark:hover:bg-white/5 transition-colors">

                                        <td className="px-6 py-4 whitespace-nowrap text-gray-800 dark:text-gray-200 font-bold">{ParentFmt(r.createdAt)}</td>

                                        <td className="px-6 py-4">

                                            <span className="px-3 py-1 rounded-full text-xs font-bold" style={{ backgroundColor: `${PARENT_STATUS_COLORS[r.status]}22`, color: PARENT_STATUS_COLORS[r.status] || '#94a3b8', border: `1px solid ${PARENT_STATUS_COLORS[r.status]}44` }}>

                                                {PARENT_STATUS_AR[r.status] || r.status}

                                            </span>

                                        </td>

                                        <td className="px-6 py-4 text-gray-800 dark:text-gray-300 font-medium">{r.reason || '—'}</td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    </div>

                </div>

            )}

        </div>

    );
}

export default ParentAttendanceTab;